import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class DetailsPageTitleService {
  constructor(private readonly title: Title) {}

  setDetailsPageTitle(dynamicTitleElement: string): void {
    const currentTitleElements = this.title
      .getTitle()
      .split('-')
      .map(titleElement => titleElement.trim());

    const newTitleElements: Array<string> = [...currentTitleElements];

    newTitleElements.splice(
      newTitleElements.length - 1,
      0,
      dynamicTitleElement,
    );

    const newTitle = newTitleElements
      .filter(titleElement => titleElement !== '')
      .join(' - ');

    this.title.setTitle(newTitle);
  }
}
